/**
 * Resolve company logo / upload paths for website + ERP backend layouts.
 * DB stores paths like /uploads/logos/company_logo_....png
 */
export function getErpApiBase() {
  const raw =
    import.meta.env.VITE_ERP_API_URL ||
    import.meta.env.VITE_API_BASE_URL ||
    '';
  return String(raw).trim().replace(/\/$/, '');
}

export function getErpBackendRoot() {
  const apiBase = getErpApiBase();
  if (!apiBase || apiBase === '/api') {
    return '';
  }
  return apiBase.replace(/\/api$/, '');
}

export function resolveCompanyAssetUrl(path) {
  if (!path) return '';
  const trimmed = String(path).trim();
  if (!trimmed) return '';
  if (/^https?:\/\//i.test(trimmed) || trimmed.startsWith('data:')) {
    return trimmed;
  }

  const normalized = trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
  const backendRoot = getErpBackendRoot();

  if (!backendRoot) {
    // Local Vite proxies /uploads → ERP backend
    return normalized;
  }

  if (normalized.startsWith('/uploads/')) {
    return `${backendRoot}${normalized}`;
  }

  return `${backendRoot}${normalized}`;
}
